interface StepProps {
  value: number
  current: number
  disabled?: boolean
  onClick?: () => void
}
function Step({ value, current, disabled = false, onClick }: StepProps) {
  const stepStyle =
    current - value > 0
      ? 'border-cta-active border-3 bg-white text-cta'
      : current - value < 0
      ? 'border-cta border-3 bg-neutral-200 text-neutral-500'
      : 'border-sunshine-yellow border-3 bg-white text-cta-active'
  return (
    <div
      className={`w-12 h-12 ${stepStyle} rounded-full text-center pt-1.5 text-serif text-2xl `}
      onClick={disabled === false && onClick ? () => onClick() : () => {}}
    >
      {value}
    </div>
  )
}

export default Step
